<!-- 资讯详情 -->
<template>
  <div class="frame">
    <Breadcrumb :breadcrumbs="breadcrumbs" />
    <div class="content">
      <div class="title">{{ detail.title }}</div>
      <div class="info">
        <span>{{
          (detail.publishTime || detail.createTime).split(" ")[0]
        }}</span>
        <span>阅读量：1234</span>
      </div>
      <div class="detail" v-html="detail.contentStr"></div>
    </div>
  </div>
</template>

<script>
import { menuRoutes } from "../router/menuRoutes";
import Breadcrumb from "../components/breadCrumb.vue";
export default {
  components: { Breadcrumb },
  data() {
    return {
      breadcrumbs: [],
      detail: {
        createTime: "",
      },
    };
  },
  created() {
    const preRoute = menuRoutes.find(
      (ele) => ele.path == "/" + this.$route.params.type
    ); // 用于寻找二级面包屑
    this.breadcrumbs = [
      { path: "/", name: "首页" },
      { path: preRoute.path, name: preRoute.name },
    ];
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let res = await this.$api.getNewDetail({ id: this.$route.params.id });
      if (res.code == 0) {
        this.detail = res.data;
        this.breadcrumbs.push({ name: res.data.title });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.frame {
  width: 100%;
}
.content {
  padding: 30px 0;

  .title {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    margin-bottom: 20px;
  }
  .info {
    text-align: center;
    font-size: 13px;
    color: #999;

    span + span {
      margin-left: 20px;
    }
  }
  .detail {
    width: 1200px;
    min-height: 50vh;
    margin: 40px auto 0;

    :deep(img) {
      max-width: 100%;
      height: auto;
    }
    :deep(video) {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
